import { render, staticRenderFns } from "./ShopOwnerCouponManage.vue?vue&type=template&id=1b43400b&scoped=true&"
import script from "./ShopOwnerCouponManage.vue?vue&type=script&lang=ts&"
export * from "./ShopOwnerCouponManage.vue?vue&type=script&lang=ts&"
import style0 from "./ShopOwnerCouponManage.vue?vue&type=style&index=0&id=1b43400b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b43400b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VImg,VRow})
